import { StyleTheme, Theme } from '../core/theme.model';

const light: StyleTheme = {
  name: 'ntt-theme',
  core: {
    common: {
      colors: {
        text: '#333',
        background: '#F7F7F7',
      },
    },
    simpleCard: {
      colors: {
        background: '#FFF',
      },
    },
  },
  theme: {
    colors: {
      primary: '#0271BB',
      secondary: '#AAA',
      success: '#198754',
      danger: '#DC3545',
      warning: '#FD7E14',
      info: '#0DCAF0',
    },
  },
};

const dark: StyleTheme = {
  ...light,
  name: 'ntt-theme-dark',
  core: {
    common: {
      colors: {
        text: '#fff',
        background: '#111',
      },
    },
    simpleCard: {
      colors: {
        background: '#333',
      },
    },
  },
};

export const NDBSTheme: Theme = { light, dark };
